import { render, staticRenderFns } from "./WorkspaceShare.vue?vue&type=template&id=0944f0db&scoped=true&"
import script from "./WorkspaceShare.vue?vue&type=script&lang=js&"
export * from "./WorkspaceShare.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceShare.scss?vue&type=style&index=0&id=0944f0db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944f0db",
  null
  
)

export default component.exports